import React from "react";
import {
  Box,
  Flex,
  Text,
  Heading,
  List,
  ListItem,
  ListIcon,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalFooter,
  ModalBody,
  useDisclosure,
} from "@chakra-ui/react";
import { CheckIcon } from "@chakra-ui/icons";
import { Trans } from "react-i18next";

const ListItemIcon = () => {
  return <ListIcon as={CheckIcon} color="brand.secondary.500" />;
};

export const PlanetFitnessPromo = ({ onCancel, onBack }) => {
  const { isOpen, onOpen, onClose } = useDisclosure({ defaultIsOpen: true });
  return (
    <Modal isOpen={isOpen} size={"xl"} isCentered>
      <ModalOverlay />
      <ModalContent
        bg={"linear-gradient(307.03deg, #5c2e85 3.68%, #762b85 100%)"}
        boxShadow={""}
      >
        <ModalBody>
          <Box textAlign="center" letterSpacing=".01rem" color={"white"}>
            <Text
              size={"lg"}
              mt={8}
              color={"brand.secondary.500"}
              fontWeight={"bold"}
            >
              <Trans i18nKey={"error.member_type_requirement"}>
                Your membership does not include access to this feature. Please
                see a Staff member for more information.
              </Trans>
            </Text>
            <Heading size={"xl"} mt={8}>
              <Trans i18nKey={"promo.line1"} ns={"planetfitness"}>
                PF BLACK CARD®
              </Trans>
            </Heading>
            <Text size={"lg"} mb={8}>
              <Trans i18nKey={"promo.line2"} ns={"planetfitness"}>
                All the Perks, Now with PF+
              </Trans>
            </Text>
            <Heading size={"md"}>
              <Trans i18nKey={"promo.line3"} ns={"planetfitness"}>
                What you get
              </Trans>
            </Heading>
            <List textAlign="left" w="80%" mx="auto" listStylePosition="inside">
              <ListItem>
                <ListItemIcon />
                <Trans i18nKey={"promo.line4"} ns={"planetfitness"}>
                  Unlimited Access to Home Club
                </Trans>
              </ListItem>
              <ListItem>
                <ListItemIcon />
                <Trans i18nKey={"promo.line5"} ns={"planetfitness"}>
                  PF App Workouts
                </Trans>
              </ListItem>
              <ListItem>
                <ListItemIcon />
                <Trans i18nKey={"promo.line6"} ns={"planetfitness"}>
                  Free In-Club Fitness Training
                </Trans>
              </ListItem>
              <ListItem>
                <ListItemIcon />
                <Trans i18nKey={"promo.line7"} ns={"planetfitness"}>
                  Free WiFi
                </Trans>
              </ListItem>
              <ListItem>
                <ListItemIcon />
                <Trans i18nKey={"promo.line8"} ns={"planetfitness"}>
                  Perks: Partner Rewards & Discounts
                </Trans>
              </ListItem>
              <ListItem>
                <ListItemIcon />
                <Trans i18nKey={"promo.line9"} ns={"planetfitness"}>
                  Bring a Guest Anytime
                </Trans>
              </ListItem>
              <ListItem>
                <ListItemIcon />
                <Trans i18nKey={"promo.line10"} ns={"planetfitness"}>
                  Use of Any Planet Fitness Worldwide
                </Trans>
              </ListItem>
              <ListItem>
                <ListItemIcon />
                <Trans i18nKey={"promo.line11"} ns={"planetfitness"}>
                  Use of Tanning
                </Trans>
              </ListItem>
              <ListItem>
                <ListItemIcon />
                <Trans i18nKey={"promo.line12"} ns={"planetfitness"}>
                  Use of Massage Chairs
                </Trans>
              </ListItem>
              <ListItem>
                <ListItemIcon />
                <Trans i18nKey={"promo.line13"} ns={"planetfitness"}>
                  Use of HydroMassage™
                </Trans>
              </ListItem>
              <ListItem>
                <ListItemIcon />
                <Trans i18nKey={"promo.line14"} ns={"planetfitness"}>
                  Use of Total Body Enhancement
                </Trans>
              </ListItem>
              <ListItem>
                <ListItemIcon />
                <Trans i18nKey={"promo.line15"} ns={"planetfitness"}>
                  50% Off Select Drinks
                </Trans>
              </ListItem>
              <ListItem>
                <ListItemIcon />
                <Trans i18nKey={"promo.line16"} ns={"planetfitness"}>
                  Premium Perks: Partner Rewards & Discounts
                </Trans>
              </ListItem>
              <ListItem>
                <ListItemIcon />
                <Trans i18nKey={"promo.line17"} ns={"planetfitness"}>
                  Exclusive PF+ App Workouts
                </Trans>
              </ListItem>
            </List>

            <Text fontSize="xs" color={"whiteAlpha.500"} mt={4}>
              <Trans i18nKey={"promo.line18"} ns={"planetfitness"}>
                Subject to annual membership fee of $49.00 plus applicable state
                and local taxes will be billed on or shortly after December 1st.
                Billed monthly to a checking account. Services and perks subject
                to availability and restrictions, including restriction on
                tanning frequency. This offer has no commitment. See club for
                details.{" "}
              </Trans>
            </Text>
          </Box>
        </ModalBody>
        <ModalFooter>
          <Flex direction={"row"} justifyContent={"space-between"} w={"full"}>
            <Button
              onClick={onCancel}
              colorScheme={"white"}
              data-testid={"cancel"}
            >
              <Trans i18nKey={"actions.cancel"}>Cancel</Trans>
            </Button>
            {onBack && (
              <Button
                onClick={onBack}
                variant="kioskPrimary"
                data-testid={"back"}
              >
                <Trans i18nKey={"actions.back"}>Back</Trans>
              </Button>
            )}
          </Flex>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
